export const InternationalTariff = [
    { id: 1, country: "AFGHANISTAN", weight: 5810, addl: 1580 },
    { id: 2, country: "ALBANIA", weight: 7610, addl: 3760 },
    { id: 3, country: "Algeria", weight: 5840, addl: 1610 },
    { id: 4, country: "Argentina", weight: 7980, addl: 4700 },
    { id: 5, country: "Australia", weight: 6120, addl: 3200 },
    { id: 6, country: "Austria", weight: 5510, addl: 1380 },
    { id: 7, country: "AZERBAIJAN", weight: 5440, addl: 1220 },
    { id: 8, country: "Bahrain", weight: 4790, addl: 560 },
    { id: 9, country: "Bangladesh", weight: 2970, addl: 640 },
    { id: 10, country: "Belarus", weight: 7990, addl: 3760 },
    { id: 11, country: "Belgium", weight: 5240, addl: 1390 },
    { id: 12, country: "Bhutan", weight: 7490, addl: 5150 },
    { id: 13, country: "Bolivia", weight: 9020, addl: 5550 },
    { id: 14, country: "BOSNIA AND HERZEGOVINA", weight: 7230, addl: 3760 },
    { id: 15, country: "Botswana", weight: 7990, addl: 3760 },
    { id: 16, country: "Brazil", weight: 7880, addl: 3270 },
    { id: 17, country: "BULGARIA", weight: 4680, addl: 1210 },
    { id: 18, country: "CANADA", weight: 6210, addl: 3360 },
    { id: 19, country: "Cayman Island", weight: 9020, addl: 8580 },
    { id: 20, country: "Cayman Island (Mer)", weight: 9400, addl: 8960 },
    { id: 21, country: "Chile", weight: 8490, addl: 4450 },
    { id: 22, country: "China", weight: 3500, addl: 1870 },
    { id: 23, country: "Costa Rica", weight: 7230, addl: 3850 },
    { id: 24, country: "CROATIA", weight: 3620, addl: 3190 },
    { id: 25, country: "CROATIA (Mer)", weight: 4380, addl: 3940 },
    { id: 26, country: "Cuba", weight: 7230, addl: 3760 },
    { id: 27, country: "Cyprus", weight: 4980, addl: 1130 },
    { id: 28, country: "CZECH REPUBLIC", weight: 5700, addl: 2610 },
    { id: 29, country: "Denmark", weight: 17190, addl: 10790 },
    { id: 30, country: "Egypt", weight: 4380, addl: 910 },
    { id: 31, country: "Eritrea", weight: 7990, addl: 3760 },
    { id: 32, country: "Ethiopia", weight: 6160, addl: 1560 },
    { id: 33, country: "Finland", weight: 6040, addl: 1330 },
    { id: 34, country: "France", weight: 5500, addl: 1850 },
    { id: 35, country: "Germany", weight: 7330, addl: 1350 },
    { id: 36, country: "Ghana", weight: 7190, addl: 2010 },
    { id: 37, country: "Greece", weight: 5410, addl: 1190 },
    { id: 38, country: "Guatemala", weight: 6090, addl: 3760 },
    { id: 39, country: "Guinea Bissau", weight: 2820, addl: 545 },
    { id: 40, country: "Hong Kong (Mer)", weight: 6880, addl: 6440 },
    { id: 41, country: "Hong Kong", weight: 5550, addl: 5110 },
    { id: 42, country: "Hungary", weight: 5540, addl: 1310 },
    { id: 43, country: "Iceland", weight: 10030, addl: 3230 },
    { id: 44, country: "India", weight: 4390, addl: 1000 },
    { id: 45, country: "Indonesia", weight: 4790, addl: 4350 },
    { id: 46, country: "Indonesia (Mer)", weight: 6680, addl: 6240 },
    { id: 47, country: "Iran", weight: 6160, addl: 1930 },
    { id: 48, country: "Iraq", weight: 4270, addl: 1560 },
    { id: 49, country: "Ireland", weight: 6460, addl: 1500 },
    { id: 50, country: "Italy", weight: 5800, addl: 1390 },
    { id: 51, country: "Ivory coast", weight: 8640, addl: 5550 },
    { id: 52, country: "Japan", weight: 7440, addl: 1620 },
    { id: 53, country: "Jordan", weight: 5070, addl: 840 },
    { id: 54, country: "Kenya", weight: 5290, addl: 1060 },
    { id: 55, country: "Korea", weight: 6330, addl: 1340 },
    { id: 56, country: "Kuwait", weight: 3800, addl: 710 },
    { id: 57, country: "Kyrgyzstan", weight: 6920, addl: 2690 },
    { id: 58, country: "Lao PDR", weight: 5570, addl: 5130 },
    { id: 59, country: "Lao PDR (Mer)", weight: 7680, addl: 7240 },
    { id: 60, country: "LATVIA", weight: 5760, addl: 2670 },
    { id: 61, country: "Luxembourg", weight: 4590, addl: 1500 },
    { id: 62, country: "Macau", weight: 6140, addl: 5710 },
    { id: 63, country: "Macau (Mer)", weight: 6900, addl: 6460 },
    { id: 64, country: "Macedonia", weight: 7420, addl: 3760 },
    { id: 65, country: "Malaysia", weight: 5800, addl: 1010 },
    { id: 66, country: "Maldives", weight: 4180, addl: 710 },
    { id: 67, country: "Mali", weight: 6090, addl: 3760 },
    { id: 68, country: "MALTA", weight: 6560, addl: 2670 },
    { id: 69, country: "Mauritania", weight: 7990, addl: 3760 },
    { id: 70, country: "Mauritius", weight: 7230, addl: 3760 },
    { id: 71, country: "Morocco", weight: 6180, addl: 2140 },
    { id: 72, country: "Nepal", weight: 3510, addl: 800 },
    { id: 73, country: "Netherlands", weight: 6210, addl: 1390 },
    { id: 74, country: "New Zealand", weight: 6280, addl: 3700 },
    { id: 75, country: "Niger", weight: 7610, addl: 4520 },
    { id: 76, country: "Nigeria", weight: 5590, addl: 1930 },
    { id: 77, country: "Norway", weight: 7830, addl: 1240 },
    { id: 78, country: "Oman", weight: 5190, addl: 590 },
    { id: 79, country: "Philippines", weight: 5210, addl: 1740 },
    { id: 80, country: "Poland", weight: 4780, addl: 1310 },
    { id: 81, country: "Portugal", weight: 6320, addl: 3230 },
    { id: 82, country: "Qatar", weight: 5280, addl: 1430 },
    { id: 83, country: "Romania", weight: 5810, addl: 1210 },
    { id: 84, country: "Russia", weight: 4830, addl: 2760 },
    { id: 85, country: "Rwanda", weight: 5370, addl: 1520 },
    { id: 86, country: "Saudi Arabia", weight: 5510, addl: 910 },
    { id: 87, country: "Senegal", weight: 7230, addl: 3760 },
    { id: 88, country: "Sierraleone (Mer)", weight: 7610, addl: 7170 },
    { id: 89, country: "Sierraleone", weight: 6470, addl: 6030 },
    { id: 90, country: "Singapore", weight: 5170, addl: 4730 },
    { id: 91, country: "Somalia (Mer)", weight: 3890, addl: 3450 },
    { id: 92, country: "Somalia", weight: 3320, addl: 2880 },
    { id: 93, country: "South Africa", weight: 5780, addl: 2310 },
    { id: 94, country: "Spain", weight: 5570, addl: 1540 },
    { id: 95, country: "Srilanka", weight: 5010, addl: 1060 },
    { id: 96, country: "Srilanka", weight: 3780, addl: 690 },
    { id: 97, country: "Sudan", weight: 6160, addl: 1560 },
    { id: 98, country: "Sweden", weight: 7810, addl: 1310 },
    { id: 99, country: "Switzerland", weight: 6930, addl: 1370 },
    { id: 100, country: "Syria", weight: 7610, addl: 3760 },
    { id: 101, country: "Tanzania", weight: 6160, addl: 1560 },
    { id: 102, country: "Thailand", weight: 4960, addl: 1230 },
    { id: 103, country: "Thailand", weight: 4230, addl: 950 },
    { id: 104, country: "Togo", weight: 7990, addl: 3760 },
    { id: 105, country: "Tunisia", weight: 5350, addl: 1500 },
    { id: 106, country: "Turkey", weight: 6370, addl: 1390 },
    { id: 107, country: "Uganda", weight: 5690, addl: 1460 },
    { id: 108, country: "UKRAINE", weight: 8740, addl: 3760 },
    { id: 109, country: "United Arab Emirates", weight: 4830, addl: 610 },
    { id: 110, country: "United Kingdom", weight: 7310, addl: 1410 },
    { id: 111, country: "United States", weight: 8440, addl: 3670 },
    { id: 112, country: "Uzbekistan", weight: 6290, addl: 1680 },
    { id: 113, country: "VIET NAM", weight: 4150, addl: 3710 },
    { id: 114, country: "Zimbabwe", weight: 6420, addl: 2950 },
]